"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionJson = exports.ConnectionJsonMapper = exports.ConnectionDynamoMapper = void 0;
var connection_dynamodb_1 = require("./connection-dynamodb");
Object.defineProperty(exports, "ConnectionDynamoMapper", { enumerable: true, get: function () { return connection_dynamodb_1.ConnectionDynamoMapper; } });
var connection_json_1 = require("./connection-json");
Object.defineProperty(exports, "ConnectionJsonMapper", { enumerable: true, get: function () { return connection_json_1.ConnectionJsonMapper; } });
var connection_model_1 = require("./connection-model");
Object.defineProperty(exports, "ConnectionJson", { enumerable: true, get: function () { return connection_model_1.ConnectionJson; } });
